import React, { useEffect, useState } from 'react';
import { Alert } from '@mui/material';
import Select from "../../ui/PortalSelect";
import * as Yup from 'yup';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { baseURL } from '../backend_url';
import axios from 'axios';
import Swal from 'sweetalert2';
import ReactPhoneInput from "react-phone-input-2";
import { loadAccessibleCompanies, readSessionUser } from '../accountAccess';
import { buildCompanyOptions, findCompanyById } from '../companyLocation/companySelection';
import UserAccountAllocation from './UserAccountAllocation';
import { messageFromError, readJsonResponse } from '../saveResponse';
import { getEntitySelectProps } from '../../ui/selectPresentation';
import {
  customizedOtpForPayload,
  normalizeCustomizedOtpInput,
  roleAllowsCustomizedOtp,
  validateCustomizedOtp,
} from './customizedOtp';
import { canonicalizeLocationAllocations } from './locationAllocations';
import { canonicalizeAccountAllocations } from './accountAllocations';

export default function NewForm() {

  const arr_location_check = [];

  const [companyDetail, setcompanyDetail] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [customizedOtp, setCustomizedOtp] = useState("");
  const [validationMsg, setValidationMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [company_id, setcompany_id] = useState('');
  const [loading, setLoading] = useState(false);
  const [locationDetail, setLocationDetail] = useState([]);
  const [locationsLoadedFor, setLocationsLoadedFor] = useState('');
  const [checkedState, setCheckedState] = useState({});
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [maxUser, setMaxUser] = useState(null);
  const [existingUser, setExistingUser] = useState(null);
  const [roleDetail, setRoleDetail] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [accountAllocated, setAccountAllocated] = useState([]);
  const [loggedInUserDetail, setLoggedInUserDetail] = useState({});
  const [phone2, setPhone2] = useState("");
  const [sq1, setSq1] = useState("");
  const [sq2, setSq2] = useState("");
  const [sq3, setSq3] = useState("");
  const [q1, setq1] = useState("In what city were you born?");
  const [q2, setq2] = useState("What is the name of your favorite pet?");
  const [q3, setq3] = useState("At what age did you start school?");
  const [submitAndSendMail, setSubmitAndSendMail] = useState("No");

  const [selectAllLocation, setSelectAllLocation] = useState(false);


  // form validation rules 
  const validationSchema = Yup.object().shape({
    userName: Yup.string()
      .required('User Name is required')
      .min(3, 'Name too short')
      .max(100, 'Name too large!'),

    userEmail: Yup.string()
      .required('User Email ID is required')
      .email('Enter a valid Email ID'),

    password: Yup.string()
      .required('Password is required')
      .min(8, 'Must be greater than 8 characters')
      .max(200, 'Must be less than 200 characters')
      .matches(
        // /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
        "Must Contain atleast 8 Characters, One Uppercase, One Lowercase and One Number "
      )

  });
  const formOptions = { resolver: yupResolver(validationSchema) };

  // get functions to build form with useForm() hook
  const { register, handleSubmit, setValue, formState: { errors } } = useForm(formOptions);

  //API call
  useEffect(() => {
    let active = true;
    const { user: foundUser, error } = readSessionUser();
    if (error) {
      setcompanyDetail([]);
      setValidationMsg(error);
      return undefined;
    }

    setLoggedInUserDetail(foundUser);

    loadAccessibleCompanies(baseURL, foundUser, 'User_Account Access')
      .then((accounts) => {
        if (active) setcompanyDetail(accounts);
      })
      .catch((loadError) => {
        if (active) {
          setcompanyDetail([]);
          setValidationMsg(loadError.message || 'Accounts could not be loaded.');
        }
      });

    return () => {
      active = false;
    };
  }, []);

  // Load the selected account by its immutable ID. Company names are not
  // unique across tenants and must never be used to resolve ownership.
  useEffect(() => {
    const company_obj = findCompanyById(companyDetail, company_id);
    if (!company_obj) {
      setLocationDetail([]);
      setCheckedState({});
      setLocationsLoadedFor('');
      setSelectAllLocation(false);
      return undefined;
    }

    let active = true;
    const selectedCompanyId = String(company_obj._id);
    setMaxUser(company_obj.no_of_users);
    setLocationDetail([]);
    setCheckedState({});
    setLocationsLoadedFor('');
    setSelectAllLocation(false);

    //API call for getting data from Location DB
    const requestOptions1 = {
      method: "GET",
      mode: 'cors',
      headers: {
        "Content-Type": "application/json",
      },
    };

    fetch(
      baseURL + "/get_user_details/" + selectedCompanyId
      + "?companyNumber=" + encodeURIComponent(selectedCompanyId),
      requestOptions1
    )
      .then((res) => readJsonResponse(res, 'Users'))
      .then((data) => {
        if (!active) return;
        if (data === 'New Entry !!') {
          setExistingUser(0);
          return;
        }
        if (!data || typeof data !== 'object' || Array.isArray(data)) {
          throw new Error('The server did not return a valid User summary.');
        }
        setExistingUser(Number(data.existing_users) || 0);
      })
      .catch((error) => {
        if (!active) return;
        setExistingUser(null);
        setValidationMsg(messageFromError(
          error,
          'Users could not be loaded for this account. Please try again.',
        ));
      });

    //API call for getting data from Location DB
    const requestOptions2 = {
      method: "GET",
      mode: 'cors',
      headers: {
        "Content-Type": "application/json",
      },
    };

    fetch(
      baseURL + "/get_company_location/" + selectedCompanyId
      + "?companyNumber=" + encodeURIComponent(selectedCompanyId),
      requestOptions2
    )
      .then((res) => readJsonResponse(res, 'Account locations'))
      .then((data) => {
        if (!active) return;
        if (!data || !Array.isArray(data.res)) {
          throw new Error('The server did not return a valid Account location list.');
        }
        const locations = data.res;
        setLocationDetail(locations);
        setCheckedState(canonicalizeLocationAllocations(locations, {}));
        setLocationsLoadedFor(selectedCompanyId);
      })
      .catch((error) => {
        if (!active) return;
        setValidationMsg(messageFromError(
          error,
          'Account locations could not be loaded. Please try again.',
        ));
      });

    axios.get(
      baseURL + "/user_role_setup/" + selectedCompanyId + "*Corporate"
      + "?companyNumber=" + encodeURIComponent(selectedCompanyId)
    )
      .then((res) => {
        if (!active) return;
        if (!Array.isArray(res.data)) {
          throw new Error('The server did not return a valid Role list.');
        }
        setRoleDetail(res.data)
      })
      .catch((error) => {
        if (!active) return;
        setRoleDetail([]);
        setValidationMsg(messageFromError(
          error,
          'Roles could not be loaded for this account. Please try again.',
        ));
      })

    return () => {
      active = false;
    };

  }, [companyDetail, company_id])

  useEffect(() => {
    if (!company_id) return;
    setAccountAllocated((current) => (
      current.includes(String(company_id))
        ? current
        : [String(company_id), ...current]
    ));
  }, [company_id]);



  //OnSubmit code
  const submitHandler = () => {
    setLoading(true)
    setSuccessMsg("");
    setValidationMsg("");

    if (!company_id) {
      const message = 'Please select an account name to proceed';
      setValidationMsg(message);
      Swal.fire({ icon: 'error', title: 'User was not created', text: message });
      setLoading(false)
      return;
    }

    if (selectedRole === '') {
      Swal.fire("Role Name field Can't be empty")
      setLoading(false)
      return;
    }

    if (locationsLoadedFor !== String(company_id)) {
      const message = 'Account locations are still loading. Please wait and try again.';
      setValidationMsg(message);
      Swal.fire({ icon: 'info', title: 'Locations are loading', text: message });
      setLoading(false)
      return;
    }

    const customizedOtpError = validateCustomizedOtp(selectedRoleRecord, customizedOtp);
    if (customizedOtpError) {
      Swal.fire({ icon: 'error', title: 'Invalid Customized OTP', text: customizedOtpError });
      setLoading(false)
      return;
    }
    if (sq1.toString().trim() === '') {
      Swal.fire("Please fill answer for security question 1")
      setLoading(false)
      return;
    }
    if (sq2.toString().trim() === '') {
      Swal.fire("Please fill answer for security question 2")
      setLoading(false)
      return;
    }
    if (sq3.toString().trim() === '') {
      Swal.fire("Please fill answer for security question 3")
      setLoading(false)
      return;
    }


    const locationAllocatedPayload = canonicalizeLocationAllocations(
      locationDetail,
      checkedState,
    );
    const accountAllocatedPayload = canonicalizeAccountAllocations(
      companyDetail,
      company_id,
      accountAllocated,
    );

    //API call for inserting data into DB
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        "company_id": company_id.toString(),
        "companyNumber": company_id.toString(),
        "company_name": companyName,
        "user_email": userEmail,
        "user_name": userName,
        "password": password,
        "selected_role": selectedRole,
        "customized_otp": customizedOtpForPayload(selectedRoleRecord, customizedOtp),
        "account_allocated": accountAllocatedPayload,
        "location_allocated": locationAllocatedPayload,
        "contact_no": phone2,
        'created_by': loggedInUserDetail.userEmail,
        'updated_by': loggedInUserDetail.userEmail,
        'logged_in': false,
        's_q1': q1,
        's_q2': q2,
        's_q3': q3,
        's_a1': sq1.toString().trim(),
        's_a2': sq2.toString().trim(),
        's_a3': sq3.toString().trim(),
        'send_mail': submitAndSendMail

      }),
    };

    fetch(baseURL + "/add_new_user", requestOptions)
      .then(res => readJsonResponse(res, 'User creation'))
      .then(data => {
        if (!data || typeof data !== 'object' || Array.isArray(data)) {
          throw new Error('The server did not return a valid User creation result. Your form has been kept.');
        }

        if (data.status === 'already Exists') {
          const message = typeof data.msg === 'string' && data.msg.trim()
            ? data.msg
            : 'A User with this email already exists.';
          setValidationMsg(message);
          Swal.fire({ icon: 'error', title: 'User was not created', text: message });
        }
        else if (data.status === 'limit touched') {
          const message = typeof data.msg === 'string' && data.msg.trim()
            ? data.msg
            : 'The maximum number of active Users has been reached.';
          setValidationMsg(message);
          Swal.fire({ icon: 'error', title: 'User was not created', text: message });
        }
        else if (data.status === 'success' && typeof data.msg === 'string' && data.msg.trim()) {
          const message = "New user created successfully with User Email - " + data.msg;
          setSuccessMsg(message);
          setcompany_id('');
          setUserEmail('');
          setUserName('');
          setCustomizedOtp('');
          setCompanyName('');
          setPassword('');
          setValue('userEmail', '');
          setValue('userName', '');
          setValue('password', '');
          setShowPassword(false);
          setExistingUser("");
          setMaxUser("");
          setPhone2("");
          setSq1("");
          setSq2("");
          setSq3("");
          setSubmitAndSendMail("No");
          setAccountAllocated([]);
          setSelectedRole('');
          Swal.fire({ icon: 'success', title: 'User created', text: message });
        }
        else {
          throw new Error('The server did not confirm that the User was created. Your form has been kept.');
        }
      })
      .catch(error => {
        console.error('Unable to create user:', error)
        const message = messageFromError(error, 'Unable to create User. Please try again.');
        setValidationMsg(message)
        Swal.fire({ icon: 'error', title: 'User was not created', text: message });
      })
      .finally(() => setLoading(false));
  }; //submitHandler func ends here

  //Option for company name
  const RoleNameOptions = roleDetail.map((value) => (

    { value: value.role_name, label: value.role_name }
  ));

  const selectedRoleRecord = roleDetail.find((value) => value.role_name === selectedRole) || null;
  const canUseCustomizedOtp = roleAllowsCustomizedOtp(selectedRoleRecord);

  const handleInputChangeRoleName = characterEntered => {
    const nextRoleName = characterEntered?.value || '';
    const nextRole = roleDetail.find((value) => value.role_name === nextRoleName) || null;
    setSelectedRole(nextRoleName);
    if (!roleAllowsCustomizedOtp(nextRole)) setCustomizedOtp('');
    setAccountAllocated(company_id ? [String(company_id)] : []);
  };

  //Option for company name
  const companyNameOptions = buildCompanyOptions(companyDetail);
  const selectedCompanyOption = companyNameOptions.find(
    (option) => option.value === String(company_id),
  ) || null;

  const handleInputChangeCompanyName = characterEntered => {
    const company = findCompanyById(companyDetail, characterEntered?.value);
    setcompany_id(characterEntered?.value || '');
    setCompanyName(company?.company_name || '');
    setSelectedRole('');
    setCustomizedOtp('');
    setRoleDetail([]);
    setAccountAllocated(characterEntered?.value ? [String(characterEntered.value)] : []);
    setLocationDetail([]);
    setCheckedState({});
    setLocationsLoadedFor('');
    setSelectAllLocation(false);
  };

  const handleGeneratePassword = () => {
    let pass = generatePassword()
    setPassword(pass)
    setValue('password', pass)
  }

  const generatePassword = () => {
    var length = 8,
      charset2 = "abcdefghijklmnopqrstuvwxyz",
      charset1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      charset3 = "0123456789",
      retVal = "";
    for (var i = 0, n = charset1.length; i < 3; ++i) {
      retVal += charset1.charAt(Math.floor(Math.random() * n));
    }

    for (var i = 0, n = charset2.length; i < 2; ++i) {
      retVal += charset2.charAt(Math.floor(Math.random() * n));
    }

    for (var i = 0, n = charset3.length; i < 3; ++i) {
      retVal += charset3.charAt(Math.floor(Math.random() * n));
    }
    return shuffle_pass(retVal);
  }


  const shuffle_pass = (pass_str) => {
    var a = pass_str.split(""),
      n = a.length;

    for (var i = n - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = a[i];
      a[i] = a[j];
      a[j] = tmp;
    }
    return a.join("");
  }

  //Location Tick Check 
  const handleLocationCheck = (location_name) => {

    const location_hash_temp = { ...checkedState };
    location_hash_temp[location_name] = !location_hash_temp[location_name];
    setCheckedState(location_hash_temp);

    let arr = Object.keys(location_hash_temp);
    let flag = true;
    for (let i = 0; i < arr.length; i++) {

      if (location_hash_temp[arr[i]] === false) {
        flag = false;
        break;
      }
    }
    if (flag) {
      setSelectAllLocation(true);
    }
    else {
      setSelectAllLocation(false);
    }

  }


  //Location Tick Check 
  const handleAllLocationCheck = () => {

    const location_hash_temp = { ...checkedState };
    setSelectAllLocation(!selectAllLocation);

    let arr = Object.keys(location_hash_temp);
    for (let i = 0; i < arr.length; i++) {

      if (!selectAllLocation) {
        location_hash_temp[arr[i]] = true
      }
      else {
        location_hash_temp[arr[i]] = false
      }
    }

    setCheckedState(location_hash_temp);
  }


  return (
    <>
      <div className="row pt-4">
        <div className="col-8 mx-3">
          <span style={{ color: '#1E1E1E', fontSize: '21px' }}>Setup New User: </span>
        </div>
      </div>
      <form className="row g-3" onSubmit={handleSubmit(submitHandler)}>
        <div className="row pt-5">
          {/* <div className="col-1"></div> */}
          <div className="col-8 mx-3">
            <div className='row'>
              {validationMsg ? (
                <div className='row mb-3'>
                  <Alert severity="error">{validationMsg}</Alert>
                </div>
              ) : (
                ""
              )}

              {successMsg ?

                (

                  <div className="alert alert-success alert-dismissible fade show" role="alert">
                    {successMsg}
                    <button className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setSuccessMsg('')}></button>
                  </div>
                )
                : ""}



              <div className="col-md-2 mb-3">
                <label htmlFor="company_name" className="form-label">
                  Account Name
                </label>
              </div>
              <div className="col-md-5  mb-3">

                <Select
                  {...getEntitySelectProps()}
                  value={selectedCompanyOption}
                  inputId="company_name"
                  name="company_name"
                  options={companyNameOptions}
                  onChange={handleInputChangeCompanyName}
                  placeholder="Select Account name"
                  isClearable
                />


              </div>
              <div className="col-md-1 mb-3"></div>
              <div className="col-md-2 mb-3">
                {/* <label htmlFor="company_id" className="form-label">
                  Account ID
                </label> */}
              </div>
              <div className="col-md-2 mb-3">
                {/* <input
                  type="text"
                  className="form-control"
                  value={company_id}
                  id="company_id"
                  disabled
                /> */}
              </div>

              <div className="col-md-2 mb-3">
                <label htmlFor="user_email" className="form-label">
                  User Email
                </label>
              </div>
              <div className="col-md-5 mb-3">
                <input
                  type="text"
                  className={`form-control ${errors.userEmail ? 'is-invalid' : ''}`} {...register('userEmail')}
                  id="user_email"
                  value={userEmail ?? ""}
                  onChange={(e) => setUserEmail(e.target.value)}
                  placeholder="eg: abc123@xyz.com"
                />
                <div className="invalid-feedback">{errors.userEmail?.message}</div>
              </div>

              <div className="col-md-1 mb-3"></div>


              <div className="col-md-2 mb-3">
                <label htmlFor="max_user" className="form-label">
                  Max Allowed Users
                </label>
              </div>
              <div className="col-md-2 mb-3">
                <input
                  type="text"
                  className="form-control"
                  value={maxUser}
                  id="max_user"
                  disabled
                />
              </div>


              <div className="col-md-2 mb-3">
                <label htmlFor="existing_user" className="form-label">
                  Role Name
                </label>
              </div>
              <div className="col-md-5 mb-3">
                <Select
                  value={{ value: selectedRole, label: (selectedRole ? selectedRole : "Select Role Name") }}
                  inputId="role_name"
                  name="role_name"
                  options={RoleNameOptions}
                  onChange={handleInputChangeRoleName}
                />

              </div>


              <div className="col-md-1 mb-3"></div>
              <div className="col-12">
                <UserAccountAllocation
                  accounts={companyDetail}
                  homeAccountId={company_id}
                  role={selectedRoleRecord}
                  allocatedAccountIds={accountAllocated}
                  onChange={setAccountAllocated}
                />
              </div>
              <div className="col-md-2 mb-3">
                <label htmlFor="existing_user" className="form-label">
                  Existing Active Users
                </label>
              </div>
              <div className="col-md-2 mb-3">
                <input
                  type="text"
                  className="form-control"
                  value={existingUser}
                  id="existing_user"
                  disabled
                />
              </div>



              <div className="col-md-2 mb-3">
                <label htmlFor="user_name" className="form-label">
                  User Name
                </label>
              </div>
              <div className="col-md-5 mb-3">
                <input
                  type="text"
                  className={`form-control ${errors.userName ? 'is-invalid' : ''}`} {...register('userName')}
                  id="user_name"
                  value={userName ?? ""}
                  onChange={(e) => setUserName(e.target.value)}
                  placeholder="User Name"
                />
                <div className="invalid-feedback">{errors.userName?.message}</div>
              </div>

              <div className="w-100" aria-hidden="true"></div>
              <div className="col-md-2 mb-3">
                <label htmlFor="contact_no" className="form-label">
                  Contact No.
                </label>
              </div>
              <div className="col-md-5 mb-3 user-phone-field">
                <ReactPhoneInput
                  enableSearch
                  searchPlaceholder="Search country"
                  value={phone2}
                  placeholder="Enter contact number"
                  onChange={(value) => setPhone2(value)}
                  inputProps={{
                    id: 'contact_no',
                    name: 'contact_no',
                    'aria-label': 'Contact number',
                  }}
                />

              </div>
              <div className="col-md-5 mb-3"></div>



              <div className="col-md-2 mb-3">
                <label htmlFor="password" className="form-label">
                  Password
                </label>
              </div>
              <div className="col-md-5 mb-3">
                <input
                  type={showPassword ? "text" : "password"}
                  className={`form-control ${errors.password ? 'is-invalid' : ''}`} {...register('password')}
                  value={password}
                  id="password"
                  onChange={(e) => setPassword(e.target.value)}
                />

                <div className='row mx-1'>
                  <div className="col-md-3 form-check mt-3">

                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                      checked={showPassword} onChange={() => setShowPassword(!showPassword)} />
                    <label className="form-check-label" for="flexCheckDefault">
                      Show Password
                    </label>

                  </div>
                  <div className="col-md-2 mt-3"></div>
                  <div className="col-md-1 mt-3">
                    <span title='Click to auto generate password' onClick={handleGeneratePassword} style={{ cursor: 'pointer' }}><AutorenewIcon /> </span>
                  </div>

                  <div className="col-md-6 mt-3">
                    <label className="form-check-label" for="flexCheckDefault">
                      Generate Password
                    </label>
                  </div>

                  <div className="col-md-1 mb-3"></div>

                </div>

                <div className="invalid-feedback">{errors.password?.message}</div>
              </div>
              {canUseCustomizedOtp && (
                <>
                  <div className="w-100" aria-hidden="true"></div>
                  <div className="col-md-2 mb-3">
                    <label htmlFor="customized_otp" className="form-label">
                      Customized OTP
                    </label>
                  </div>
                  <div className="col-md-5 mb-3">
                    <input
                      type="text"
                      className="form-control"
                      value={customizedOtp}
                      id="customized_otp"
                      name="customized_otp"
                      maxLength={6}
                      inputMode="numeric"
                      autoComplete="one-time-code"
                      pattern="[0-9]{6}"
                      aria-describedby="customized_otp_help"
                      onChange={(event) => setCustomizedOtp(normalizeCustomizedOtpInput(event.target.value))}
                    />
                    <div id="customized_otp_help" className="form-text">
                      Optional. Enter exactly 6 digits to use this fixed login OTP instead of an emailed OTP.
                    </div>
                  </div>
                  <div className="col-md-5 mb-3"></div>
                </>
              )}
            </div>

            <div className='row'>
              <div className="col-md-2 mb-3">
                <label htmlFor="company_name" className="form-label">
                  Security Question 1
                </label>
              </div>
              <div className="col-md-3  mb-3">


                <label htmlFor="q1" className="form-label">
                  {q1}
                </label>

              </div>
              <div className="col-md-3  mb-3">

                <input
                  type="text"
                  className="form-control"
                  value={sq1}
                  id="q1"
                  onChange={(e) => setSq1(e.target.value)}
                />
              </div>
              {/* <div className="col-md-1 mb-3"></div> */}
              <div className="col-md-2 mb-3">

              </div>
              <div className="col-md-2 mb-3">
                {/* <input
                  type="text"
                  className="form-control"
                  value={company_id}
                  id="company_id"
                  disabled
                /> */}
              </div>
            </div>

            <div className='row'>
              <div className="col-md-2 mb-3">
                <label htmlFor="company_name" className="form-label">
                  Security Question 2
                </label>
              </div>
              <div className="col-md-3  mb-3">


                <label htmlFor="q2" className="form-label">
                  {q2}
                </label>

              </div>
              <div className="col-md-3  mb-3">
                <input
                  type="text"
                  className="form-control"
                  value={sq2}
                  id="q2"
                  onChange={(e) => setSq2(e.target.value)}
                />
              </div>
              {/* <div className="col-md-1 mb-3"></div> */}
              <div className="col-md-2 mb-3">

              </div>
              <div className="col-md-2 mb-3">
                {/* <input
                  type="text"
                  className="form-control"
                  value={company_id}
                  id="company_id"
                  disabled
                /> */}
              </div>

            </div>

            <div className='row'>
              <div className="col-md-2 mb-3">
                <label htmlFor="company_name" className="form-label">
                  Security Question 3
                </label>
              </div>
              <div className="col-md-3  mb-3">


                <label htmlFor="q3" className="form-label">
                  {q3}
                </label>

              </div>
              <div className="col-md-3  mb-3">

                <input
                  type="text"
                  className="form-control"
                  value={sq3}
                  id="q3"
                  onChange={(e) => setSq3(e.target.value)}
                />
              </div>
              {/* <div className="col-md-1 mb-3"></div> */}
              <div className="col-md-2 mb-3">

              </div>
              <div className="col-md-2 mb-3">
                {/* <input
                  type="text"
                  className="form-control"
                  value={company_id}
                  id="company_id"
                  disabled
                /> */}
              </div>

            </div>

          </div>
        </div>

        <div className='row pt-3'>
          {companyName ? (
            <>
              {/* <div className="col-md-2 mb-3"></div> */}

              <div className="col-md-5 mb-3" >
                <span style={{ color: '#1E1E1E', fontSize: '21px' }}>Location Access:</span>
                <table className="table text-center table-bordered text-center " >
                  <thead>
                    <tr >
                      <th scope="col" style={{ width: '120px' }} >Location Name</th>
                      <th scope="col" style={{ width: '70px' }} >Allocated</th>

                    </tr>
                  </thead>
                  <tbody >
                    {locationDetail.length > 0 &&
                      <tr>
                        <td>{"Select All"}</td>
                        <td scope="col" style={{ width: '70px' }}>
                          <input type="checkbox" className='form-check-input' checked={selectAllLocation} onChange={() => { handleAllLocationCheck() }} />
                        </td>
                      </tr>
                    }
                    {
                      locationDetail.length > 0 ? (
                        locationDetail.map((val) => (
                          <tr key={val._id}>
                            <td>{val.location_name}</td>
                            <td scope="col" style={{ width: '70px' }}>
                              <input type="checkbox" className='form-check-input' checked={checkedState[val.location_id]} onChange={() => handleLocationCheck(val.location_id)} />
                            </td>
                          </tr>
                        ))

                      ) : ""
                    }

                  </tbody>
                </table>
              </div>



            </>
          ) : ""}


        </div>

        <div className="row">
          <div className="col-1 mx-4"></div>
          <div className="col-4">


            {loading ? (

              <button className="btn btn-success" type="button" disabled>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: 5 }}></span>
                Submit
              </button>

            ) : (
              <button type="submit" className="btn btn-success" >
                Submit
              </button>

            )}
          </div>
          <div className="col-4">


            {loading ? (

              <button className="btn btn-info" type="button" disabled>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: 5 }}></span>
                Submit & Send Mail
              </button>

            ) : (
              <button type="submit" className="btn btn-info" onClick={() => setSubmitAndSendMail("Yes")}>
                Submit & Send Mail
              </button>

            )}
          </div>
          <div className="col-md-5"></div>



          <div className="col-3"></div>
        </div>
      </form>
      <br />
    </>
  );
}
